import { useGetAiAccessStatus } from '@repo/api-codegen';
import { createMockableHook } from '@repo/common/utils/createMockableHook';

function useAiWorkspaceSettingEnabledInternal() {
	const { data } = useGetAiAccessStatus({});

	return (
		data?.restriction_info.restriction_type !== 'workspace_settings_disabled'
	);
}

export const [useAiWorkspaceSettingEnabled, MockUseAiWorkspaceSettingEnabled] =
	createMockableHook(useAiWorkspaceSettingEnabledInternal);
